// Skjermleser-kunngjøringer (PRD US21). Toasts forsvinner og fanges ikke
// alltid opp av skjermlesere, så lagring og feil sies også i to faste
// live-regioner: «status» (høflig) og «alert» (avbryter). Regionene lages
// første gang de trengs og ligger usynlig nederst i body.

type Politeness = "polite" | "assertive";

const regions: Partial<Record<Politeness, HTMLElement>> = {};

const region = (politeness: Politeness) => {
  const existing = regions[politeness];
  if (existing && document.body.contains(existing)) return existing;
  const el = document.createElement("div");
  el.setAttribute("role", politeness === "assertive" ? "alert" : "status");
  el.setAttribute("aria-live", politeness);
  el.setAttribute("aria-atomic", "true");
  el.dataset.announcer = politeness;
  Object.assign(el.style, {
    position: "absolute",
    width: "1px",
    height: "1px",
    margin: "-1px",
    padding: "0",
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    whiteSpace: "nowrap",
    border: "0",
  });
  document.body.appendChild(el);
  regions[politeness] = el;
  return el;
};

export const announce = (
  message: string,
  politeness: Politeness = "polite",
) => {
  const text = message.trim();
  if (!text || typeof document === "undefined") return;
  const el = region(politeness);
  // Tøm først, så samme melding to ganger på rad også blir lest.
  el.textContent = "";
  window.setTimeout(() => {
    el.textContent = text;
  }, 50);
  // Rydd etter en stund, så gammel tekst ikke blir liggende i regionen.
  window.setTimeout(() => {
    if (el.textContent === text) el.textContent = "";
  }, 7000);
};
